import { Action } from 'redux';

import { isAction } from '../utils';
import {
  GetTokenFunction,
  LogoutFunction
} from './state';

const TOKEN_UPDATE = 'AUTH.UPDATE_TOKEN';

export interface TokenUpdate extends Action {
  logoutFunction: LogoutFunction;
  type: typeof TOKEN_UPDATE;
  getTokenFunction: GetTokenFunction;
}

export function updateTokenAction(
    logoutFunction: LogoutFunction,
    getTokenFunction: GetTokenFunction
): TokenUpdate {
  return {
    getTokenFunction,
    logoutFunction,
    type: TOKEN_UPDATE
  };
}
export const isTokenUpdate = isAction<TokenUpdate>(TOKEN_UPDATE);
